<template>
  <div class="container orders-page">
    <v-head></v-head>
    <v-left current="orders" active="diy"></v-left>
    <div>
      <div class="filter-dic clearfix">
        <div class="fl">
          <el-input
            size="small"
            v-model="filter.keyword"
            placeholder="搜订单号、工厂单号、备注"
            clearable
            @clear="search"
            @change="search"
            style="width: 300px"
            class="w400 input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </div>
        <div class="fr">
          <span class="pointer" @click="redirect('/orders/upload-files')">图片</span>
        </div>
      </div>
      <div>
        <div>
          <ul v-loading="loading" style="padding-bottom: 100px">
            <li
              class="create-li fl"
              v-for="(item, index) in list_data.list"
              :key="index"
            >
              <div class="diy-dom" style="margin:0 auto;">
                <div
                  class="template-img"
                  :style="{
                    'background-color': item.bg_color
                      ? item.bg_color
                      : 'transparent',
                  }"
                >
                  <el-image
                    style="width: 100%; height: 100%"
                    :src="item.image_diy"
                    :preview-src-list="[item.image_diy]"
                  >
                  </el-image>
                </div>
              </div>
              <div style="text-align: center; padding-top: 10px">
                <div class="clearfix" style="margin-bottom:10px;">
                  <div class="fl">{{item.real_model_name}}</div>
                  <div class="fr">{{ item.ctime_format }}</div>
                  <!-- <div class="fr"><el-switch v-model="item.is_share_bool" @change="switchShare(item)"></el-switch>分享</div> -->
                </div>
                <div>
                  <el-button size="mini" class="pointer" @click="toCreate(item)">Cre-T</el-button>
                  <el-button size="mini" class="pointer" @click="toDownload(item)">Export</el-button>
                  <el-button size="mini" class="pointer" @click="toDownloadImg(item)">DRAW</el-button>
                </div>
              </div>
            </li>
            <li style="clear: both"></li>
          </ul>
        </div>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          :page-sizes="[24, 30, 40, 50, 100]"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
      </div>
    </div>
    <component :is="popName" :row="edit_row"></component>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const pop_create_by_result = (resolve) => require(["@/pages/diy/templates/_pop_create_by_result"], resolve);
const pop_download_create = (resolve) => require(["@/pages/orders/create/_pop_download_create"], resolve);
export default {
  components: {
    "v-head": head,
    "v-left": left,
    pop_create_by_result,
    pop_download_create,
  },
  data() {
    return {
      loading: false,
      popName: null,
      edit_row: null,
      filter: {
        page: 1,
        size: 24,
        keyword: "",
      },
      list_data: {
        size: 24,
        page: 1,
        total: 0,
        list: [],
      },
    };
  },
  methods: {
    changePage(e) {
      this.filter.page = e;
      this.getList();
    },
    search() {
      this.filter.page = 1;
      this.getList();
    },
    toCreate(row) {
      this.edit_row = row;
      this.popName = "pop_create_by_result";
    },
    toDownload(row) { 
      this.edit_row = row;
      this.popName = "pop_download_create";
    },
    toDownloadImg(row) { 
      this.download(row.image_diy_draw)
    },
    updateCreate(item) { 
      this.$http
        .post("/v1/pri/diy-template/update-template-by-create", {diy_create_id:item.id})
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "更新成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    switchShare(item) { 
      this.$http
        .post("/v1/pri/diy-template/share-create", {diy_create_id:item.id, is_share:item.is_share_bool ? 1 : 0})
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "更新成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    getList() {
      this.loading = true;
      this.$http
        .post("/v1/pri/orders/diy-create-list", this.filter)
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.list_data = res.data;
          }
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
.orders-page .filter-dic {
  margin-bottom: 14px;
}
.create-li {
  margin: 10px 10px 0 0;
  position: relative;
  border: 1px solid #dfdfdf;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}
.create-li .diy-dom {
  width: 156px;
  height: 310px;
  background-position: center center;
  background-size: 100% 100%;
  position: relative;
}
.create-li .diy-dom img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.create-li .el-icon-close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 11;
  cursor: pointer;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/create/Index.vue